var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
		_vm.$style['base-icon-button'],
		{
			[_vm.$style['base-icon-button--white']]: _vm.white,
			[_vm.$style['base-icon-button--primary']]: _vm.primary,
			[_vm.$style['base-icon-button--disabled']]: _vm.disabled,
			[_vm.$style['base-icon-button--loading']]: _vm.loading
		}
	],on:{"click":event => !_vm.disabled && _vm.$emit('click', event)}},[(_vm.withRipple || _vm.white || _vm.primary)?_c('BaseRipple'):_vm._e(),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],class:_vm.$style['base-icon-button__content']},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }